import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';

class ServicesSection extends Component {

    render() {
        return (
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <div className="col-md-8 pb-40 header-text">
                        <FormattedMessage id='services_sec_title'
                                          tagName={"h1"}
                                          description='say hello to Howard.'
                                          defaultMessage='{title_srv_sec_str}'
                                          // values={{title_srv_sec_str: this.props.services_sec_title}}
                        ></FormattedMessage>
                        <p>
                            Who are in extremely love with eco friendly system.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="single-service">
                            <h4><span className="lnr lnr-user"></span><FormattedMessage id='services_sec_fea_expert'
                                                                                        defaultMessage='Experts'
                            ></FormattedMessage></h4>
                            <FormattedMessage id='services_sec_fea_expert_intro'
                                              tagName={"p"}
                                              defaultMessage='Experts'
                            ></FormattedMessage>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-service">
                            <h4><span className="lnr lnr-license"></span><FormattedMessage id='services_sec_fea_agile'
                                                                                        defaultMessage='Experts'
                            ></FormattedMessage></h4>
                            <FormattedMessage id='services_sec_fea_agile_intro'
                                              tagName={"p"}
                                              defaultMessage='Experts'
                            ></FormattedMessage>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-service">
                            <h4><span className="lnr lnr-phone"></span><FormattedMessage id='services_sec_fea_worth'
                                                                                         defaultMessage='Experts'
                            ></FormattedMessage></h4>
                            <FormattedMessage id='services_sec_fea_worth_intro'
                                              tagName={"p"}
                                              defaultMessage='Experts'
                            ></FormattedMessage>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-service">
                            <h4><span className="lnr lnr-rocket"></span><FormattedMessage id='services_sec_fea_integration'
                                                                                          defaultMessage='Experts'
                            ></FormattedMessage></h4>
                            <FormattedMessage id='services_sec_fea_integration_intro'
                                              tagName={"p"}
                                              defaultMessage='Experts'
                            ></FormattedMessage>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-service">
                            <h4><span className="lnr lnr-diamond"></span><FormattedMessage id='services_sec_fea_full'
                                                                                           defaultMessage='Experts'
                            ></FormattedMessage></h4>
                            <FormattedMessage id='services_sec_fea_full_intro'
                                              tagName={"p"}
                                              defaultMessage='Experts'
                            ></FormattedMessage>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-service">
                            <h4><span className="lnr lnr-bubble"></span><FormattedMessage id='services_sec_fea_cust'
                                                                                          defaultMessage='Experts'
                            ></FormattedMessage></h4>
                            <FormattedMessage id='services_sec_fea_cust_intro'
                                              tagName={"p"}
                                              defaultMessage='Experts'
                            ></FormattedMessage>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ServicesSection;



// WEBPACK FOOTER //
// ./src/components/ServicesSection.js